import { useEffect, useRef, useState } from "react";
import { CashAdvance } from "shared/interfaces/CashAdvance";
import MeuAdiantamentoHeader from "./MeuAdiantamentoHeader";
import { Divider, Row } from "antd";
import Duvidas from "./Duvidas";
import { Trans, useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import { isMobile } from "react-device-detect";
import MeuAdiantamento from "./MeuAdiantamento";
import { ReactComponent as Logo } from "shared/assets/images/contrato-icon.svg";
import { SpecialCampaignEnum } from "shared/enums/SpecialCampaignEnum";
import { toast } from "react-toastify";
import ContratoAssinado from "./dados-contrato/ContratoAssinado";
import logger from "shared/service/LoggerService";

const { REACT_APP_CLICKSIGN_URL } = process.env;

declare global {
  interface Window {
    Clicksign: any;
  }
}

interface Props {
  advance: CashAdvance;
  reloadCashAdvance: () => void;
}

const getIdFromUrl = (url: string) => {
  const urlParts = url.split("/");
  return urlParts[urlParts.length - 1];
};

const AdiantamentoAssinaturaContrato: React.FC<Props> = (props) => {
  const { advance, reloadCashAdvance } = props;

  const [showMeuAdiantamento, setShowMeuAdiantamento] =
    useState<boolean>(false);
  const { t } = useTranslation();
  const widgetRef = useRef<any>(null);
  const [isActive, setIsActive] = useState<boolean>(false);
  const [signed, setSigned] = useState<boolean>(false);
  const history = useHistory();

  const onClickHome = () => {
    history.push("/");
  };

  const onClickAssinar = () => {
    if (advance?.contractTobeSignedUrl) {
      logger.message("User starting advance contract signature", {
        transaction: "Advance Contract",
        tags: { flow: "advance_contract" },
        category: "contract_sign_start",
      });

      setIsActive(true);

      const signatureId = getIdFromUrl(advance?.contractTobeSignedUrl);
      widgetRef.current = new window.Clicksign(signatureId);

      widgetRef.current.endpoint = REACT_APP_CLICKSIGN_URL;
      widgetRef.current.origin = window.origin;
      widgetRef.current.mount("container");

      widgetRef.current.on("loaded", function () {
        logger.message("Clicksign widget loaded", {
          transaction: "Advance Contract",
          tags: { flow: "advance_contract" },
          category: "clicksign_loaded",
        });
      });

      widgetRef.current.on("signed", function () {
        logger.message("Advance contract signed successfully", {
          transaction: "Advance Contract",
          tags: { flow: "advance_contract" },
          category: "contract_signed",
        });
        setSigned(true);
      });

      widgetRef.current.on("resized", function (event: any) {
        const iframe = document.getElementById("container");
        if (iframe) iframe.style.height = event.data.height + "px";
      });
    } else {
      logger.error(new Error("Contract URL not available"), {
        transaction: "Advance Contract",
        tags: { flow: "advance_contract" },
      });
      toast.error<string>(t("pages.Adiantamentos.erroAssinarContrato"));
    }
  };

  useEffect(() => {
    return () => {
      widgetRef.current?.unmount();
    };
  }, [widgetRef]);

  if (signed)
    return (
      <ContratoAssinado
        advance={advance}
        reloadCashAdvance={reloadCashAdvance}
      />
    );

  return (
    <div
      className="flex-column-between contrato-assinatura"
      style={{
        minHeight: isMobile ? "calc(100vh - 64px)" : "100vh",
        paddingLeft: isMobile ? 0 : 94,
      }}
    >
      <div
        id="container"
        style={{ height: "100%", display: isActive ? "block" : "none" }}
      />
      {!isActive && (
        <>
          <div
            className="migracao"
            style={{
              flex: 1,
              display: "flex",
              flexDirection: "column",
            }}
          >
            <MeuAdiantamentoHeader
              setShowMeuAdiantamento={setShowMeuAdiantamento}
              showMeuAdiantamento={showMeuAdiantamento}
            />
            <Divider />
            {showMeuAdiantamento ? (
              <MeuAdiantamento advance={advance} />
            ) : (
              <>
                <div className="confirma-adiantamento-intro">
                  <Logo />
                  <h1 className="title">
                    {t("pages.Adiantamentos.contratoEnviadoTitulo")}
                  </h1>
                  <p
                    style={{ maxWidth: isMobile ? "unset" : 650 }}
                    className="texto"
                  >
                    <>
                      {advance.specialCampaign ===
                        SpecialCampaignEnum.HenriqueEJuliano && (
                        <p style={{ marginTop: "1rem", marginBottom: "1rem" }}>
                          <Trans
                            i18nKey={t(
                              "pages.CampanhasEspeciais.HenriqueJuliano.contratoAssinaturaDisclaimer"
                            )}
                          />
                        </p>
                      )}

                      <Trans
                        i18nKey={t("pages.Adiantamentos.contratoEnviadoTexto")}
                      />
                    </>
                  </p>
                </div>
                <Row
                  justify="center"
                  style={{
                    flex: 1,
                    justifyContent: "flex-end",
                    alignItems: "center",
                    flexDirection: "column",
                    gap: 12,
                  }}
                >
                  <button
                    className="botao-roxo continuar"
                    onClick={onClickAssinar}
                  >
                    {t("pages.Adiantamentos.assinar")}
                  </button>
                  <button className="botao-borda-roxa" onClick={onClickHome}>
                    {t("pages.Adiantamentos.botaoHome")}
                  </button>
                </Row>
              </>
            )}
          </div>

          <div className="footer" style={{ paddingLeft: 8 }}>
            <Duvidas />
          </div>
        </>
      )}
    </div>
  );
};

export default AdiantamentoAssinaturaContrato;
